import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import WebUrlProcessor from '../../components/pdfchange.vue';
import ToolDescription from '../../components/ToolDescription.vue';
export default {
  __name: 'WebUrlPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "网页截图工具",
        "current-page": "weburl"
      }, {
        default: _withCtx(() => [_createVNode(ToolDescription, {
          title: "网页截图工具使用说明",
          description: "本工具可以帮助您轻松地将任意网页转换为图片或PDF，适用于保存网页内容、创建网页存档或分享网页内容等场景。",
          features: [{
            title: '完整截图',
            description: '抓取整个网页，包括滚动部分，生成一张完整的长图'
          }, {
            title: '可视区域截图',
            description: '仅截取当前可见区域的网页内容'
          }, {
            title: '自定义区域',
            description: '选择网页的特定区域进行截图'
          }, {
            title: '多种格式',
            description: '支持PNG、JPG、WEBP和PDF等多种输出格式'
          }]
        }), _createVNode(WebUrlProcessor)]),
        _: 1
      });
    };
  }
};